import { FormInstance } from 'antd/lib/form'
import { useForm } from 'antd/lib/form/Form'
import { PreviewResponse } from 'Tasks/CustomTask/UI/common/PreviewResponse/PreviewResponse'
import { TurnPrimaryResponse } from 'Tasks/CustomTask/UI/common/TurnResponse/TurnPrimaryResponse/TurnPrimaryResponse'
import { TurnStepResponse } from 'Tasks/CustomTask/UI/common/TurnResponse/TurnStepResponse/TurnStepResponse'
import { CustomForm } from 'Types/CustomTask.types'
import { PrimaryResponseFormType, TurnResponseFormType } from 'Types/Tasks.types'

type TurnDataPropsType = {
    turn: number
    response: string
    responseAnnotationValues: {
        accuracy: string
        instruction_following: string
        skill_check: string
        skill_gaps: string
    }
    firstIncorrectStep: number | null
    steps: {
        content: string
        number: number
    }[]
    turnValues: {
        accuracy: string
        error_correction: string | null
        error_identification: string | null
        python_or_text: string
        step_number: number
    }[]
    setPrimaryResponseForm: (form: FormInstance<PrimaryResponseFormType>) => void
    setTurnStepResponseForm: (form: FormInstance<TurnResponseFormType>) => void
    isReadOnly: boolean
    setForms: (forms: CustomForm) => void
}

export const TurnContainerData = (props: TurnDataPropsType) => {
    const {
        turn,
        response,
        responseAnnotationValues,
        firstIncorrectStep,
        steps,
        turnValues,
        setPrimaryResponseForm,
        setTurnStepResponseForm,
        isReadOnly,
    } = props
    const [primaryResponseForm] = useForm<PrimaryResponseFormType>()
    const [turnStepResponseForm] = useForm<TurnResponseFormType>()

    return (
        <>
            <PreviewResponse
                turn={turn}
                retryCount={0}
                responseValue={response}
                onClickRetry={() => {}}
                isReviewMode={true}
            />
            <TurnPrimaryResponse
                setPrimaryResponseForm={setPrimaryResponseForm}
                form={primaryResponseForm}
                onClickProceed={() => {}}
                disabled={isReadOnly}
                isReviewMode={true}
                initialValues={{
                    isCorrect: responseAnnotationValues.accuracy === 'YES',
                    followInstructions: responseAnnotationValues.instruction_following === 'YES',
                    skillsUsed: responseAnnotationValues.skill_check,
                    skillsGap: responseAnnotationValues.skill_gaps,
                }}
            />
            <TurnStepResponse
                setTurnStepResponseForm={setTurnStepResponseForm}
                firstIncorrectStep={firstIncorrectStep}
                setFirstIncorrectStep={() => {}}
                steps={steps.filter((_, index) => index < turnValues.length)}
                isCorrectResponse={responseAnnotationValues.accuracy === 'YES'}
                submitTurnData={() => {}}
                humanResponseNeeded={true}
                turn={turn}
                retryCount={0}
                hasManualSteps={false}
                form={turnStepResponseForm}
                isReviewMode={true}
                isReadOnly={props.isReadOnly}
                initialValues={{
                    human_final_answer: '',
                    values: turnValues,
                }}
            />
        </>
    )
}
